<script setup>
import { AccordionContent } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  class: { type: String, default: '' },
  forceMount: { type: Boolean, default: undefined },
  asChild: { type: Boolean, default: false },
  as: { type: null, default: undefined },
})
</script>

<template>
  <AccordionContent
    v-bind="props"
    :class="cn(
      'overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
      props.class
    )"
  >
    <div class="pb-4 pt-0">
      <slot />
    </div>
  </AccordionContent>
</template>
